import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { AgenciesStoresDTO } from '@/api/agencies-stores/get-agencies-stores'

export const mockGetAgenciesStores = http.get(
  '/api/booking/v1/users/agencies-stores',
  () => {
    const data: AgenciesStoresDTO = {
      timestamp: new Date().toISOString(),
      data: Array.from({ length: 50 }).map(() => ({
        city: faker.location.city(),
        taxPayerId: faker.string.numeric(14),
        companyId: faker.number.int({ min: 10000, max: 99999 }),
        corporateName: faker.company.name(),
        name: faker.company.name(),
        stateAbbreviation: faker.location.state({ abbreviated: true }),
      })),
    }

    return HttpResponse.json(data)
  },
)
